import { message as staticMessage } from 'antd';
import { ApiError } from '../api/client';
import { getMessage } from './antdBridge';
/**
 * Uniform mapping of server error codes → Hebrew messages. Every screen calls
 * `notifyError(err)` from a catch block so users see the same phrasing for
 * the same class of failure (cycle, duplicate, has_dependents, ...).
 */
export function humanizeError(err) {
    if (err instanceof ApiError) {
        switch (err.code) {
            // Server owns the full message (it enumerates every blocker + prepends
            // "לא ניתן למחוק: ..."), so we just pass it through verbatim.
            case 'has_dependents': return err.message || 'לא ניתן למחוק — יש תלויות';
            case 'cycle': return 'לא ניתן ליצור מעגל בתנאי-קדם';
            case 'required_depends_on_optional': return 'שיעור חובה לא יכול לתלות בשיעור רשות';
            case 'cross_grade_prereq': return 'תנאי-קדם חייבים להישאר באותה כיתה';
            case 'blocking_assessment_ambiguous_grade':
                return 'הבוחן החוסם מקושר לכיתות שונות — יש לנקות רשומות קיימות תחילה';
            case 'invalid_discount': return 'אחוז ההנחה חייב להיות אחד מ: 20, 30, 40, 100';
            case 'duplicate': return err.message || 'כפילות';
            case 'assessment_linkage_mismatch': return 'שדות הבוחן אינם תואמים לסוג הבוחן';
            case 'passing_assessment_already_linked': return 'לשיעור הזה כבר יש בוחן מעבר';
            case 'empty_level': return err.message || 'רמה ריקה — יש להוסיף לפחות תבנית אחת';
            case 'missing_field': return err.message || 'שדה חסר או לא תקין';
            case 'unauthorized': return 'אין הרשאה';
            case 'network': return 'בעיית רשת — נסה שוב';
            default: return err.message || err.code;
        }
    }
    return err.message || 'שגיאה';
}
/**
 * Prefer the context-bound antd message instance (via <App> + AntdBridge)
 * since it renders reliably under React 19. The static import is a fallback
 * for the tiny window before the bridge mounts, plus a final console line
 * so nothing ever fails silently at the developer level either.
 */
function toast(kind, text) {
    const m = getMessage();
    if (m) {
        if (kind === 'error')
            m.error(text);
        else
            m.success(text);
        return;
    }
    // Pre-mount fallback — should be rare in practice.
    if (kind === 'error')
        staticMessage.error(text);
    else
        staticMessage.success(text);
    // eslint-disable-next-line no-console
    console[kind === 'error' ? 'error' : 'info']('[toast]', text);
}
export function notifyError(err, prefix) {
    const text = humanizeError(err);
    toast('error', prefix ? `${prefix}: ${text}` : text);
}
export function notifySuccess(text) {
    toast('success', text);
}
